export const PROGRESS_STATUS = {
  BEFORE_COMPLETED: 0,
  COMPLETED: 1
}

export const LOADING_OVERLAY_TYPE = {
  LABEL: 0,
  LOAD_ASSETS: 1
}

export const IS_TRIAL = false
export const IS_DEBUG = false
export const VERSION = '1.0.1'
